var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocalStorage } from "react-use";
import Statistic from "../Semantic/Statistic";
import styles from '../../styles/DailyStats.module.scss';
import Bar from "./Bar";
var calculateStreaks = function (list) {
    var result = {
        currentStreak: 0,
        maxStreak: 0,
        distribution: {
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
        },
        mostRecentWinNumber: 0,
    };
    var isCurrent = true;
    var streak = 0;
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var _a = list_1[_i], _codexNumberStr = _a[0], winNumber = _a[1];
        if (isCurrent && winNumber)
            result.currentStreak += 1;
        else
            isCurrent = false;
        if (winNumber) {
            streak += 1;
            result.distribution["".concat(winNumber)] += 1;
            if (!result.mostRecentWinNumber)
                result.mostRecentWinNumber = winNumber;
        }
        else {
            if (streak > result.maxStreak)
                result.maxStreak = streak;
            streak = 0;
        }
    }
    if (streak > result.maxStreak)
        result.maxStreak = streak;
    return result;
};
var DailyStats = function (_a) {
    var storedWinMap = useLocalStorage('storedWinMap', {})[0];
    if (!storedWinMap)
        storedWinMap = {};
    var sortedWins = Object.entries(storedWinMap).sort(function (_a, _b) {
        var numStringA = _a[0];
        var numStringB = _b[0];
        return (Number(numStringA) > Number(numStringB) ? -1 : 1);
    });
    var _b = calculateStreaks(sortedWins), currentStreak = _b.currentStreak, maxStreak = _b.maxStreak, distribution = _b.distribution, mostRecentWinNumber = _b.mostRecentWinNumber;
    var numberPlayed = sortedWins.length;
    var winPercentage = Math.round(Object.values(storedWinMap).filter(function (isWin) { return isWin; }).length / numberPlayed * 100);
    var maxDistribution = Object.values(distribution).sort().reverse()[0];
    return (_jsxs("div", __assign({ className: styles.dailyStatsOuter }, { children: [_jsx("h4", { children: "Daily Mode Stats" }, void 0), _jsxs("div", __assign({ className: styles.statDiv }, { children: [_jsx(Statistic, { size: "tiny", label: "Played", value: numberPlayed }, void 0), _jsx(Statistic, { size: "tiny", label: "Win %", value: winPercentage }, void 0), _jsx(Statistic, { size: "tiny", label: "Current Streak", value: currentStreak }, void 0), _jsx(Statistic, { size: "tiny", label: "Max Streak", value: maxStreak }, void 0)] }), void 0), _jsx("h4", { children: "Guess Distribution" }, void 0), Object.entries(distribution).map(function (_a) {
                var winNumber = _a[0], count = _a[1];
                return (_jsx(Bar, { winNumber: winNumber, count: count, max: maxDistribution, mostRecentWinNumber: mostRecentWinNumber }, winNumber));
            })] }), void 0));
};
export default DailyStats;
